import store from '../store/index';

let entryUrl = null;

const guard = async (to, from, next) => {
    if (store.getters['isUserLoggedIn']) {
        if (entryUrl) {
            const url = entryUrl;
            entryUrl = null;

            return next(url); // goto stored url
        } else {
            return next(); // all is fine
        }
    }

    await store.dispatch('checkAuth');

    // we use await as this async request has to finish
    // before we can be sure

    if (store.getters['isUserLoggedIn']) {
        next();
    } else {
        entryUrl = to.path; // store entry url before redirect
        next({ name: 'Login' });
    }
};

export { guard };
